"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_1st__month__free(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_187e7df4-18a3-42af-9441-d349574664e5",
    "data-name": "187e7df4-18a3-42af-9441-d349574664e5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "_86c3e49b-fa9b-4760-b18b-223b5a252907",
    "data-name": "86c3e49b-fa9b-4760-b18b-223b5a252907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "80 80 96 70 96 122",
    style: {
      fill: "none",
      stroke: "#e60000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.64,77.85a26.12,26.12,0,0,1-.11,36.92l-.43.42a26.11,26.11,0,0,1-18.57,31.92h0l-.53.13a26.11,26.11,0,0,1-32,18.36l-.57-.16a26.12,26.12,0,0,1-36.93-.06l-.5-.48a26.11,26.11,0,0,1-31.87-18.64c-.05-.17-.09-.33-.13-.5a26.11,26.11,0,0,1-18.36-32c.05-.19.1-.38.16-.57a26.12,26.12,0,0,1,.11-36.92l.43-.42A26.11,26.11,0,0,1,44.86,43.9h0l.53-.13a26.11,26.11,0,0,1,32-18.35h0l.51.15a26.12,26.12,0,0,1,36.92.11l.42.43a26.11,26.11,0,0,1,31.92,18.57h0c.05.19.09.38.14.57a26.11,26.11,0,0,1,18.36,32,2,2,0,0,1-.16.57Z",
    transform: "translate(0 0)",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 54,
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  })));
}

var _default = ic_1st__month__free;
exports.default = _default;